import { useSelector } from 'react-redux';
import { useMedia } from 'react-use';
import { MEDIA_QUERY_DESKTOP_XS } from '../von-dyck-media-queries';
import { getMyGrade } from '../../components/user/selectors';

export const useNewMobilePaginatorIsVisible = () => {
    const grade = useSelector(getMyGrade);
    const isGradeSatisfies = grade && grade >= 5;

    const isMobile = useMedia(MEDIA_QUERY_DESKTOP_XS);

    const shouldShowNewMobilePaginator = Boolean(isGradeSatisfies && isMobile);

    return shouldShowNewMobilePaginator;
};
